import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { AppService } from '../app.service';

@Component({
  selector: 'app-billingstatement',
  templateUrl: './billingstatement.component.html',
  styleUrls: ['./billingstatement.component.scss'],
  providers: [AppService, IceNavService]
})
export class BillingstatementComponent implements OnInit {

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    ptSvc: PatientService,
    private acctSvc: AccountingService,
    private router: Router) {
  }

  ngOnInit() {
  }

}
